import CloseIcon from "@assets/images/CloseModal.svg";
import RefreshIcon from "@assets/images/refresh-primary.svg";
import { Box, Button, Divider, Drawer } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { AtpCtpDialogProps } from "@saleor/changeOrder/components/AtpCtpDialog";
import AtpCtpTableData from "@saleor/changeOrder/components/AtpCtpDialog/AtpCtpTable";
import useStyles from "@saleor/changeOrder/components/AtpCtpDialog/styles";
import { DATA_CHOICE } from "@saleor/changeOrderExport/components/ModalInputParameter";
import Checkbox from "@saleor/components/Checkbox";
import DialogProcessing from "@saleor/components/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import {
  AtpctpActionType,
  InquiryMethodType,
  useExportOrderAtpCtpRequestMutation
} from "@saleor/graphql";
import useBulkActions from "@saleor/hooks/useBulkActions";
import { renderCollection } from "@saleor/misc";
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

const AtpCtpDialog: React.FC<AtpCtpDialogProps> = props => {
  const {
    open,
    onClose,
    handleSubmit,
    listAtpCtp,
    title,
    orderId,
    isDisapearItem,
    displayByOrderNo,
    displayOrderNo,
    refetchData,
    loading
  } = props;
  const classes = useStyles();

  const [finalData, setFinalData] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);

  const converValueInquiryToEnum = (value: string): InquiryMethodType => {
    if (value === DATA_CHOICE.EXPORT) {
      return InquiryMethodType.EXPORT;
    }
    if (value === InquiryMethodType.ASAP) {
      return InquiryMethodType.ASAP;
    }
  };
  const [
    getDataAtpCtp,
    { data: dataSearch, loading: loadingAtpCtp }
  ] = useExportOrderAtpCtpRequestMutation({
    variables: {
      input: listAtpCtp.map(item => ({
        orderNo: orderId,
        itemNo: item.itemNo,
        lineId: item.id,
        quantity: item.quantity,
        plant: item.plant,
        requestDate: item.requestDate,
        inquiryMethod:
          converValueInquiryToEnum(item.inquiryMethod) ||
          InquiryMethodType.EXPORT
      }))
    }
  });

  useEffect(() => {
    getDataAtpCtp();
  }, []);

  const activeDataList = useMemo(
    () => [...finalData].filter(e => !e.disabled),
    [finalData]
  );

  const listAtpCtpData = useMemo(() => {
    const items = dataSearch?.exportOrderAtpCtpRequest?.items || [];
    const itemsFailed = dataSearch?.exportOrderAtpCtpRequest?.itemsFailed || [];
    const mappedItems = items.map(item => ({
      ...item,
      disabled: false
    }));
    const mappedItemsFailed = itemsFailed.map(item => ({
      ...item,
      disabled: true
    }));
    return [...mappedItems, ...mappedItemsFailed];
  }, [dataSearch?.exportOrderAtpCtpRequest?.items]);

  useEffect(() => {
    if (dataSearch?.exportOrderAtpCtpRequest && !listAtpCtpData.length) {
      onClose();
    }
  }, [dataSearch?.exportOrderAtpCtpRequest]);

  const { isSelected, toggle, listElements, reset, set } = useBulkActions([]);
  const intl = useIntl();

  const handleCheckboxAll = () => {
    if (listElements.length === activeDataList.length) {
      reset();
      return;
    }
    set(activeDataList.map(item => `${item.lineId}`));
  };

  const getCalculatedItemNo = (orderLine: any, index: number) => {
    const itemNo = orderLine?.itemNo;
    const calculatedItemNoPrefix = itemNo?.split(".")[0] || itemNo;
    const calculatedItemNoSuffix = itemNo?.split(".")[1] || itemNo;
    let calculatedItemNo;
    if (Number(calculatedItemNoSuffix) === 1) {
      calculatedItemNo = calculatedItemNoPrefix;
    } else {
      calculatedItemNo = index * 10 + latestValue;
    }
    return Number(calculatedItemNo);
  };

  const handleRollbackAllItem = () => {
    handleSubmit({
      variables: {
        input: {
          items: listAtpCtpData
            .filter(e => {
              if (finalData.find(line => line.lineId === e.lineId)) {
                return e;
              }
            })
            .map((orderline, index) => {
              delete orderline.__typename;
              delete orderline.disabled;

              return {
                ...orderline,
                listItems: orderline?.listItems?.map(e => {
                  if (e.__typename) {
                    delete e.__typename;
                  }
                  return e;
                }),
                calculatedItemNo: getCalculatedItemNo(orderline, index),
                action: AtpctpActionType.ROLLBACK
              };
            })
        }
      }
    });
  };

  useEffect(() => {
    setFinalData(listAtpCtpData);
  }, [listAtpCtpData]);

  const handleClose = () => {
    handleRollbackAllItem();
    if (isUpdated && refetchData) {
      refetchData();
    }
    onClose();
  };

  const disapearItem = () => {
    const newData = [...finalData].filter(e => {
      if (!listElements.includes(`${e.lineId}`)) {
        return e;
      }
    });
    setFinalData(newData);
    set([]);
    if (!newData.length) {
      onClose();
    }
  };

  const latestValue = 10;

  const handleSubmitUpdateOrderLine = (status: AtpctpActionType) => {
    if (listElements.length) {
      handleSubmit({
        variables: {
          input: {
            // headerCode: dataSearch?.atpCtpRequest?.headerCode,
            items: listElements.map((e, index) => {
              const orderline = finalData.find(ol => `${ol?.lineId}` === e);

              delete orderline.__typename;
              delete orderline.disabled;

              return {
                ...orderline,
                // originalQuantity: orderline?.originalQuantity || 0,
                // quantity: orderline?.quantity || "0",
                listItems: orderline?.listItems?.map(e => {
                  if (e.__typename) {
                    delete e.__typename;
                  }
                  return e;
                }),
                calculatedItemNo: getCalculatedItemNo(orderline, index),
                action:
                  status === AtpctpActionType.COMMIT
                    ? AtpctpActionType.COMMIT
                    : AtpctpActionType.ROLLBACK
              };
            })
          }
        }
      });
      setIsUpdated(true);
    }
  };

  useEffect(() => {
    if (isDisapearItem) {
      disapearItem();
    }
  }, [isDisapearItem]);

  return (
    <>
      <Drawer
        onClose={() => {
          handleClose();
        }}
        open={open}
        anchor={"bottom"}
        PaperProps={{
          className: classes.wrapper
        }}
      >
        <div className={classes.titleWrapper}>
          <Box display={"flex"} alignItems="center">
            <MyTypography
              variant="h5"
              className={classes.titleModal}
              data-testid="title"
            >
              {title || "ATP/CTP Results"}
            </MyTypography>
            {orderId || displayByOrderNo ? (
              <Box ml={5}>
                <MyTypography variant="body1" data-testid="orderNoTitle">
                  Order No. <b>{orderId}</b>
                </MyTypography>
              </Box>
            ) : null}
          </Box>
          <div className={classes.headerClose}>
            <MyTypography variant={"caption"}>
              {intl.formatMessage({ defaultMessage: "ปิดหน้าต่าง" })}
            </MyTypography>
            <Button
              data-testid="closeButton"
              disabled={loadingAtpCtp}
              onClick={handleClose}
            >
              <img
                className={loadingAtpCtp ? classes.disabledBtn : null}
                src={CloseIcon}
                alt="Close"
              />
            </Button>
          </div>
        </div>
        <Box
          display={"flex"}
          alignItems="center"
          className={classes.rowCheckBox}
        >
          <Checkbox
            disabled={!activeDataList.length || loading}
            indeterminate={
              listElements.length > 0 &&
              listElements.length < activeDataList.length
            }
            checked={listElements.length === activeDataList.length}
            onClick={handleCheckboxAll}
            size={"small"}
            className={classes.checkbox}
            data-testid="checkbox-all"
          />
          <MyTypography variant="body2">{`เลือก`}</MyTypography>
          <></>
          <MyTypography variant="subtitle2">
            &nbsp;{listElements.length}&nbsp;
          </MyTypography>
          <MyTypography variant="body2">{` รายการ`}</MyTypography>
        </Box>
        <Divider className={classes.divider} />
        <Box className={classes.tableWrapper}>
          {renderCollection(finalData, (item, index) => (
            <div key={`${item.lineId}${index}`} className={classes.rowCheckBox}>
              <Checkbox
                size={"small"}
                checked={isSelected(`${item.lineId}`) && !item.disabled}
                onClick={() => toggle(`${item.lineId}`)}
                className={classes.checkbox}
                disabled={item.disabled || loading}
                data-testid="checkbox-line"
              />
              <AtpCtpTableData
                displayOrderNo={displayOrderNo}
                onClickCheckBox={id => toggle(`${id}`)}
                selectedData={isSelected(`${item.lineId}`)}
                data={item}
              />
            </div>
          ))}
        </Box>
        <Box
          display={"flex"}
          width="calc(100% - 8rem)"
          justifyContent={"center"}
          position={"fixed"}
          bgcolor="#F4F7FE"
          pt={4}
          pb={4}
          alignItems="center"
          zIndex={10}
          bottom={0}
        >
          <Button
            data-testid="rollbackButton"
            className={classes.btnConfirm}
            color="secondary"
            variant="outlined"
            disabled={!listElements.length || loading}
            onClick={() => {
              handleSubmitUpdateOrderLine(AtpctpActionType.ROLLBACK);
            }}
          >
            <SVG src={RefreshIcon} width={23.4} height={23.4} />
            <MyTypography
              style={{
                color: "inherit"
              }}
              variant="button2"
            >
              {intl.formatMessage({ defaultMessage: "ROLLBACK" })}
            </MyTypography>
          </Button>
          <Box mr={2} />
          <Button
            data-testid="acceptButton"
            className={classes.btnConfirm}
            color="secondary"
            variant="contained"
            disabled={!listElements.length || loading}
            onClick={() => {
              handleSubmitUpdateOrderLine(AtpctpActionType.COMMIT);
            }}
          >
            <CheckIcon />
            <MyTypography variant="button2">
              {intl.formatMessage({ defaultMessage: "ACCEPT" })}
            </MyTypography>
          </Button>
        </Box>
      </Drawer>
      <DialogProcessing
        open={loadingAtpCtp}
        description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
      />
    </>
  );
};

export default AtpCtpDialog;
